import { render, staticRenderFns } from "./WorkRoleItem.vue?vue&type=template&id=7c1c6ca1&scoped=true&"
import script from "./WorkRoleItem.vue?vue&type=script&lang=js&"
export * from "./WorkRoleItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkRoleItem.vue?vue&type=style&index=0&id=7c1c6ca1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c6ca1",
  null
  
)

export default component.exports